import React from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import { activeSchemaIdSelector } from '../../../../redux/selectors/builder';
import { IEntityCategoryFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { EntityCategories } from '../../../Categories';

interface IProps {
  entityCategories: IEntityCategoryFieldsFragment[];
}

const EntityCategoryDetails = ({ entityCategories }: IProps) => {
  const activeSchemaId = useAppSelector(activeSchemaIdSelector);

  return (
    <EntityCategories
      schemaId={activeSchemaId}
      entityCategories={entityCategories}
      isDisabled
    />
  );
};

export default EntityCategoryDetails;
